var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLocation(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 14,
    viewBox: "0 0 13 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.1691 5.07708C10.6003 2.57458 8.41743 1.44792 6.49993 1.44792C6.49993 1.44792 6.49993 1.44792 6.49451 1.44792C4.58243 1.44792 2.3941 2.56917 1.82535 5.07167C1.1916 7.86667 2.90326 10.2337 4.45243 11.7233C5.0266 12.2758 5.76326 12.5521 6.49993 12.5521C7.2366 12.5521 7.97326 12.2758 8.54201 11.7233C10.0912 10.2337 11.8028 7.87208 11.1691 5.07708ZM6.49993 7.79083C5.55743 7.79083 4.79368 7.02708 4.79368 6.08458C4.79368 5.14208 5.55743 4.37833 6.49993 4.37833C7.44243 4.37833 8.20618 5.14208 8.20618 6.08458C8.20618 7.02708 7.44243 7.79083 6.49993 7.79083Z",
    fill: "#F18A87"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.8e165b5f.svg";
export { ForwardRef as ReactComponent };